import { PLAN_DATA_RECEIVED, PLAN_DATA_UNLOAD } from './types.js'

export default function plan(state = {}, action = {}){
  switch (action.type) {
    case PLAN_DATA_RECEIVED:
      return action.data
    case PLAN_DATA_UNLOAD:
      return {}
    default:
      return state
  }
}
